import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import ChartComponent from "../Common/Chartsection";
import Select2 from "../Common/Select2Wrapper";
import api from "../../Api";
import { getUserData } from "../../helpers/utils";
import debounce from "lodash.debounce";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { useHistory } from "react-router-dom";
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const AdminDashboard = () => {
  const User = getUserData();
  const [selectedTab, setSelectedTab] = useState("daily");
  const [Data, setData] = useState([]);
  const [jobData, setjobData] = useState([]);
  const [data, setdata] = useState([]);
  const [jobviewsdata, setjobviewsdata] = useState("");
  const [jobId, setjobId] = useState([]);
  const [render, setRender] = useState(0);
  const history = useHistory();
  const dropdownRef = useRef();
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("ai");
  const [loading, setLoading] = useState(false);
  const handleChangeStatus = async (e, id) => {
    e.preventDefault();
    var formdata = {
      status: "Reviewed",
    };
    try {
      const res = await api.UpdateApplicationStatus(id, formdata);
    } catch (err) {}
  };
  // const fetchJobs = debounce(async () => {
  //   if (!searchKeyword) return;
  //   try {
  //     setLoading(true);
  //     const response = await api.getSearchEmpjob(User?._id, searchKeyword);
  //     if (response && response.length > 0) {
  //       setjobData(
  //         response.map((job) => ({
  //           value: job._id,
  //           label: job.title,
  //         }))
  //       );

  //       // Set the default selected job to the first result
  //       setSearchKeyword(response[0].title || ""); // Default to the first title
  //       setjobId(response[0]._id || ""); // Default to the first job ID
  //       setShowDropdown(true); // Show dropdown when jobs are fetched
  //     } else {
  //       setjobData([]); // Clear data if no results
  //       setShowDropdown(false);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching jobs:", error);
  //     setLoading(false);
  //   }
  // }, 500);

  // // Update job search keyword and trigger fetch
  // const handleSearchChange = (e) => {
  //   setSearchKeyword(e.target.value);
  //   setShowDropdown(true); // Show dropdown while typing
  // };

  // useEffect(() => {
  //   if (searchKeyword.trim() !== "") {
  //     fetchJobs();
  //   } else {
  //     setjobData([]);
  //     setShowDropdown(false);
  //   }
  // }, [searchKeyword]);

  const handleJobSelect = (job) => {
    setjobId(job.value); // Update the selected job ID
    setSearchKeyword(job.label); // Update the search keyword to the selected job's title
    setShowDropdown(false); // Hide dropdown after selection
  };
  const columns = [
    {
      name: "Activity",
      selector: (row) =>
        row?.status === "Applied"
          ? "Awaiting For Review"
          : row?.status + " a job",
      sortable: true,
    },
    {
      name: "User",
      selector: (row) => row?.applicantId?.name,
      sortable: true,
    },
    {
      name: "Time",
      selector: (row) => new Date(row?.appliedAt).toISOString().split("T")[0],
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className=" ViewDetails-btn text-white px-4 py-2 m-auto "
          onClick={(e) => {
            history.push(
              `/profile/${row?.profileId._id}`,
              row?.applicantId._id
            );
            handleChangeStatus(e, row?._id);
          }}
        >
          View Details
        </button>
      ),
    },
  ];

  useEffect(() => {
    setLoading(true);
    async function getemployeeDashboard() {
      try {
        const response = await api.getemployeedashboard();

        if (response.status !== 400) {
          setData(response);
          setLoading(false);
          setdata(response?.recentApplications);
        } else if (response.status == 400) {
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
        // Handle error
      } finally {
        setLoading(false);
      }
    }
    getemployeeDashboard();
    async function getjobsbyEmp() {
      try {
        const response = await api.getJobsByuserId(User?._id);

        if (response.status !== 400) {
          setjobData(response?.jobs);
          setjobId(response?.jobs[0]?._id);
          setLoading(false);
        } else if (response.status == 400) {
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
        // Handle error
      } finally {
        setLoading(false);
      }
    }
    getjobsbyEmp();
  }, [render]);
  const fetchJobViews = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${domainpath}/api/employer/jobviews/${jobId}?period=${selectedTab}`
      );
      const apiData = await response.json();
      setjobviewsdata(apiData); // Save API response to state
    } catch (error) {
      console.error("Error fetching job views:", error);
      setData(null); // Handle error gracefully
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobViews();
  }, [selectedTab, jobId]);
  const transformData = (data) => {
    if (!data || !Array.isArray(data)) {
      return { 2023: 100 }; // Return static data if the input is not valid
    }

    return data.reduce(
      (acc, { year, views }) => {
        acc[year] = views;
        return acc;
      },
      { 2023: 100 }
    ); // Adding the static 2023: 100 as default value
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
  const formatNumber = (num) => {
    if (num >= 1000 && num < 1000000) {
      return `${(num / 1000).toFixed(1)}K`;
    } else if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    return num;
  };
  const tabs = [
    { label: "Day", value: "daily" },
    { label: "Week", value: "weekly" },
    { label: "Month", value: "monthly" },
    { label: "Year", value: "yearly" },
  ];
  return (
    <div className="md:p-8 p-8 pt-0 hrp-Empolyers-dashboard-page">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <div
          className="dashboardsection-card flex md:gap-2 	 lg:gap-3 cursor-pointer"
          onClick={(e) => history.push("/dashboard/job-applications")}
        >
          <div className="dashboardsection-image ">
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1667_36)">
                <path
                  d="M42 26.2506V42.0006H21V26.2506H26.25V21.0006H36.75V26.2506H42ZM28.875 26.2506H34.125V23.6256H28.875V26.2506ZM39.375 34.1256H36.75V36.7506H34.125V34.1256H28.875V36.7506H26.25V34.1256H23.625V39.3756H39.375V34.1256ZM39.375 28.8756H23.625V31.5006H39.375V28.8756ZM32.0947 18.3756C31.3564 17.5417 30.4814 16.8991 29.4697 16.4479C28.458 15.9967 27.3848 15.7643 26.25 15.7506C25.1562 15.7506 24.1377 15.9557 23.1943 16.3659C22.251 16.776 21.417 17.3366 20.6924 18.0475C19.9678 18.7585 19.4004 19.5993 18.9902 20.57C18.5801 21.5407 18.375 22.5592 18.375 23.6256C18.375 24.8835 18.0947 26.0661 17.5342 27.1735C16.9736 28.2809 16.1807 29.2106 15.1553 29.9626C15.7705 30.277 16.3447 30.6393 16.8779 31.0495C17.4111 31.4596 17.9102 31.9245 18.375 32.444V39.3756C18.375 38.2956 18.1699 37.277 17.7598 36.32C17.3496 35.3629 16.7891 34.529 16.0781 33.818C15.3672 33.1071 14.5264 32.5397 13.5557 32.1159C12.585 31.692 11.5664 31.487 10.5 31.5006C9.40625 31.5006 8.3877 31.7057 7.44434 32.1159C6.50098 32.526 5.66699 33.0866 4.94238 33.7975C4.21777 34.5085 3.65039 35.3493 3.24023 36.32C2.83008 37.2907 2.625 38.3092 2.625 39.3756H0C0 38.3776 0.136719 37.4137 0.410156 36.484C0.683594 35.5544 1.07324 34.6725 1.5791 33.8385C2.08496 33.0045 2.7002 32.2663 3.4248 31.6237C4.14941 30.9811 4.95605 30.4274 5.84473 29.9626C4.83301 29.2243 4.04688 28.3014 3.48633 27.194C2.92578 26.0866 2.63867 24.8971 2.625 23.6256C2.625 22.5456 2.83008 21.527 3.24023 20.57C3.65039 19.6129 4.21094 18.779 4.92188 18.068C5.63281 17.3571 6.4668 16.7897 7.42383 16.3659C8.38086 15.942 9.40625 15.737 10.5 15.7506C11.7578 15.7506 12.9404 16.0309 14.0479 16.5915C15.1553 17.152 16.085 17.945 16.8369 18.9704C17.3564 17.945 18.0195 17.029 18.8262 16.2223C19.6328 15.4157 20.5557 14.7458 21.5947 14.2126C20.583 13.4743 19.7969 12.5514 19.2363 11.444C18.6758 10.3366 18.3887 9.14713 18.375 7.87564C18.375 6.79556 18.5801 5.77701 18.9902 4.81998C19.4004 3.86295 19.9609 3.02896 20.6719 2.31802C21.3828 1.60709 22.2168 1.0397 23.1738 0.615875C24.1309 0.192047 25.1562 -0.013031 26.25 0.000640869C27.3301 0.000640869 28.3486 0.205719 29.3057 0.615875C30.2627 1.02603 31.0967 1.58658 31.8076 2.29752C32.5186 3.00845 33.0859 3.84927 33.5098 4.81998C33.9336 5.79068 34.1387 6.80923 34.125 7.87564C34.125 9.13345 33.8447 10.3161 33.2842 11.4235C32.7236 12.5309 31.9307 13.4606 30.9053 14.2126C31.835 14.6774 32.6758 15.2585 33.4277 15.9557C34.1797 16.653 34.8154 17.4596 35.335 18.3756H32.0947ZM10.5 28.8756C11.2246 28.8756 11.9014 28.7389 12.5303 28.4655C13.1592 28.192 13.7197 27.8161 14.2119 27.3376C14.7041 26.859 15.0801 26.3053 15.3398 25.6764C15.5996 25.0475 15.7363 24.3639 15.75 23.6256C15.75 22.901 15.6133 22.2243 15.3398 21.5954C15.0664 20.9665 14.6904 20.4059 14.2119 19.9137C13.7334 19.4215 13.1797 19.0456 12.5508 18.7858C11.9219 18.526 11.2383 18.3893 10.5 18.3756C9.77539 18.3756 9.09863 18.5124 8.46973 18.7858C7.84082 19.0592 7.28027 19.4352 6.78809 19.9137C6.2959 20.3922 5.91992 20.946 5.66016 21.5749C5.40039 22.2038 5.26367 22.8874 5.25 23.6256C5.25 24.3503 5.38672 25.027 5.66016 25.6559C5.93359 26.2848 6.30957 26.8454 6.78809 27.3376C7.2666 27.8297 7.82031 28.2057 8.44922 28.4655C9.07812 28.7253 9.76172 28.862 10.5 28.8756ZM21 7.87564C21 8.60025 21.1367 9.27701 21.4102 9.90591C21.6836 10.5348 22.0596 11.0954 22.5381 11.5876C23.0166 12.0797 23.5703 12.4557 24.1992 12.7155C24.8281 12.9753 25.5117 13.112 26.25 13.1256C26.9746 13.1256 27.6514 12.9889 28.2803 12.7155C28.9092 12.442 29.4697 12.0661 29.9619 11.5876C30.4541 11.109 30.8301 10.5553 31.0898 9.92642C31.3496 9.29752 31.4863 8.61392 31.5 7.87564C31.5 7.15103 31.3633 6.47427 31.0898 5.84537C30.8164 5.21646 30.4404 4.65591 29.9619 4.16373C29.4834 3.67154 28.9297 3.29556 28.3008 3.0358C27.6719 2.77603 26.9883 2.63931 26.25 2.62564C25.5254 2.62564 24.8486 2.76236 24.2197 3.0358C23.5908 3.30923 23.0303 3.68521 22.5381 4.16373C22.0459 4.64224 21.6699 5.19595 21.4102 5.82486C21.1504 6.45377 21.0137 7.13736 21 7.87564Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_1667_36">
                  <rect width="42" height="42" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div>
            <p className="text-end text-4 ">{formatNumber(Data?.totalJobs)}</p>
            <h2 className="">
              Posted Job
              {/* Total Applications */}
            </h2>
          </div>
        </div>
        <div
          className="dashboardsection-card flex md:gap-2 justify-center lg:gap-3"
          onClick={(e) => history.push("/dashboard/manage-jobs")}
        >
          <div className="dashboardsection-image ">
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.9375 5.55273H9.29688L15.7701 27.6491H32.5876L38.0625 11.8099H16.2269"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19.355 18.3505L22.9583 21.9529L29.7334 15.1777"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.4003 36.4484C19.0563 36.4484 20.3989 35.1059 20.3989 33.4498C20.3989 31.7937 19.0563 30.4512 17.4003 30.4512C15.7442 30.4512 14.4016 31.7937 14.4016 33.4498C14.4016 35.1059 15.7442 36.4484 17.4003 36.4484Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M29.9609 36.4484C31.617 36.4484 32.9595 35.1059 32.9595 33.4498C32.9595 31.7937 31.617 30.4512 29.9609 30.4512C28.3048 30.4512 26.9622 31.7937 26.9622 33.4498C26.9622 35.1059 28.3048 36.4484 29.9609 36.4484Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div>
            <p className="">
              {formatNumber(Data?.totalShortlisted)}
              {/* <span style={{ color: "green" }}>{Data?.activeJobs}</span> */}
            </p>
            <h2 className="">
              Shortlisted
              {/* Total Jobs /Active Jobs */}
            </h2>
          </div>
        </div>
        <div
          className="dashboardsection-card flex md:gap-1 justify-center lg:gap-3"
          // onClick={(e) => history.push("/dashboard/manage-jobs")}
        >
          <div className="dashboardsection-image ">
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 17.5C13.7679 17.5 13.5454 17.5922 13.3813 17.7563C13.2172 17.9204 13.125 18.1429 13.125 18.375C13.125 18.6071 13.2172 18.8296 13.3813 18.9937C13.5454 19.1578 13.7679 19.25 14 19.25H20.125C20.3571 19.25 20.5796 19.1578 20.7437 18.9937C20.9078 18.8296 21 18.6071 21 18.375C21 18.1429 20.9078 17.9204 20.7437 17.7563C20.5796 17.5922 20.3571 17.5 20.125 17.5H14ZM13.125 14C13.125 13.7679 13.2172 13.5454 13.3813 13.3813C13.5454 13.2172 13.7679 13.125 14 13.125H27.5625C27.7946 13.125 28.0171 13.2172 28.1812 13.3813C28.3453 13.5454 28.4375 13.7679 28.4375 14C28.4375 14.2321 28.3453 14.4546 28.1812 14.6187C28.0171 14.7828 27.7946 14.875 27.5625 14.875H14C13.7679 14.875 13.5454 14.7828 13.3813 14.6187C13.2172 14.4546 13.125 14.2321 13.125 14Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.125 24.5C13.125 24.2679 13.2172 24.0454 13.3813 23.8813C13.5454 23.7172 13.7679 23.625 14 23.625H17.5C17.7321 23.625 17.9546 23.7172 18.1187 23.8813C18.2828 24.0454 18.375 24.2679 18.375 24.5V28C18.375 28.2321 18.2828 28.4546 18.1187 28.6187C17.9546 28.7828 17.7321 28.875 17.5 28.875H14C13.7679 28.875 13.5454 28.7828 13.3813 28.6187C13.2172 28.4546 13.125 28.2321 13.125 28V24.5ZM14.875 27.125V25.375H16.625V27.125H14.875ZM24.5 27.125C25.1962 27.125 25.8639 26.8484 26.3562 26.3562C26.8484 25.8639 27.125 25.1962 27.125 24.5C27.125 23.8038 26.8484 23.1361 26.3562 22.6438C25.8639 22.1516 25.1962 21.875 24.5 21.875C23.8038 21.875 23.1361 22.1516 22.6438 22.6438C22.1516 23.1361 21.875 23.8038 21.875 24.5C21.875 25.1962 22.1516 25.8639 22.6438 26.3562C23.1361 26.8484 23.8038 27.125 24.5 27.125ZM24.5 25.375C24.6181 25.3804 24.736 25.3618 24.8467 25.3204C24.9574 25.279 25.0586 25.2155 25.1441 25.1339C25.2296 25.0523 25.2977 24.9542 25.3442 24.8456C25.3908 24.7369 25.4149 24.62 25.415 24.5018C25.4151 24.3836 25.3913 24.2666 25.3449 24.1579C25.2986 24.0491 25.2307 23.9509 25.1454 23.8691C25.06 23.7873 24.959 23.7237 24.8484 23.6821C24.7377 23.6404 24.6198 23.6216 24.5018 23.6268C24.2767 23.6366 24.0641 23.7329 23.9082 23.8955C23.7523 24.0582 23.6652 24.2747 23.665 24.5C23.6648 24.7253 23.7514 24.942 23.907 25.105C24.0625 25.268 24.2749 25.3647 24.5 25.375ZM19.25 30.7842C19.25 28.9327 22.7474 28 24.5 28C26.2526 28 29.75 28.9327 29.75 30.7842V34.125H19.25V30.7842ZM21.0481 30.8193L21 30.8691V32.375H28V30.87L27.9519 30.8184C27.8084 30.6784 27.5319 30.4929 27.0979 30.3083C26.2229 29.9364 25.1431 29.75 24.5 29.75C23.8569 29.75 22.7771 29.9364 21.9021 30.3083C21.4681 30.492 21.1916 30.6792 21.0481 30.8193Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.875 6.125C14.875 5.42881 15.1516 4.76113 15.6438 4.26884C16.1361 3.77656 16.8038 3.5 17.5 3.5H24.5C25.1962 3.5 25.8639 3.77656 26.3562 4.26884C26.8484 4.76113 27.125 5.42881 27.125 6.125H30.625C31.3212 6.125 31.9889 6.40156 32.4812 6.89384C32.9734 7.38613 33.25 8.05381 33.25 8.75V35.875C33.25 36.5712 32.9734 37.2389 32.4812 37.7312C31.9889 38.2234 31.3212 38.5 30.625 38.5H11.375C10.6788 38.5 10.0111 38.2234 9.51884 37.7312C9.02656 37.2389 8.75 36.5712 8.75 35.875V8.75C8.75 8.05381 9.02656 7.38613 9.51884 6.89384C10.0111 6.40156 10.6788 6.125 11.375 6.125H14.875ZM24.5 10.5C25.1962 10.5 25.8639 10.2234 26.3562 9.73116C26.8484 9.23887 27.125 8.57119 27.125 7.875H30.625C30.8571 7.875 31.0796 7.96719 31.2437 8.13128C31.4078 8.29538 31.5 8.51794 31.5 8.75V35.875C31.5 36.1071 31.4078 36.3296 31.2437 36.4937C31.0796 36.6578 30.8571 36.75 30.625 36.75H11.375C11.1429 36.75 10.9204 36.6578 10.7563 36.4937C10.5922 36.3296 10.5 36.1071 10.5 35.875V8.75C10.5 8.51794 10.5922 8.29538 10.7563 8.13128C10.9204 7.96719 11.1429 7.875 11.375 7.875H14.875C14.875 8.57119 15.1516 9.23887 15.6438 9.73116C16.1361 10.2234 16.8038 10.5 17.5 10.5H24.5ZM17.5 5.25C17.2679 5.25 17.0454 5.34219 16.8813 5.50628C16.7172 5.67038 16.625 5.89294 16.625 6.125V7.875C16.625 8.10706 16.7172 8.32962 16.8813 8.49372C17.0454 8.65781 17.2679 8.75 17.5 8.75H24.5C24.7321 8.75 24.9546 8.65781 25.1187 8.49372C25.2828 8.32962 25.375 8.10706 25.375 7.875V6.125C25.375 5.89294 25.2828 5.67038 25.1187 5.50628C24.9546 5.34219 24.7321 5.25 24.5 5.25H17.5Z"
                fill="white"
              />
            </svg>
          </div>
          <div>
            <p className="text-center">
              {formatNumber(Data?.totalApplications)}
            </p>
            <h2 className="">Application{/* Total Applicants */}</h2>
          </div>
        </div>
        <div
          className="dashboardsection-card flex md:gap-1 justify-center lg:gap-3"
          // onClick={(e) => history.push("/dashboard/manage-jobs")}
        >
          <div className="dashboardsection-image ">
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.98 3.49172L33.3638 7.87547L34.125 9.73922V10.6055H32.8125L31.5 11.918V9.73922L27.1162 5.35547H26.25V15.8555H10.5V5.35547H5.25V31.6055H13.125L11.8125 34.2305H5.25L2.625 31.6055V5.35547L5.25 2.73047H27.1162L28.98 3.49172ZM18.375 13.1255H23.625V5.25047H18.375V13.1255ZM35.4375 13.1255L39.375 17.063L39.3225 18.8742L24.885 33.3117L24.5438 33.6267L23.5725 34.598L23.31 34.8342L15.435 38.7717L13.6763 37.013L17.6138 29.138L17.85 28.8755L18.8213 27.9042L19.1362 27.563L33.5737 13.1255H35.4375ZM19.11 32.1305L17.745 34.7555L20.475 33.4955L19.11 32.1305ZM20.9212 29.4267L22.995 31.5005L36.5137 17.9817L34.44 15.908L20.9212 29.4267Z"
                fill="white"
              />
            </svg>
          </div>
          <div>
            <h2 className="">
              <p className="text-center">
                {formatNumber(Data?.totalApplicants)}
              </p>{" "}
              Save Candidate
              {/* Total Applicants */}
            </h2>
          </div>
        </div>
      </div>

      <div className="lg:flex profileheadlinediv-main gap-5 md:pt-20">
        <div className="lg:w-3/5 animated-form profileheadlinediv">
          <div className="w-full  mx-auto  bg-white  hrp-Applications-section ">
            <div className=" hrp-Applications-heading">
              <h2 className="text-2xl font-semibold ">Job Views</h2>
            </div>{" "}
            <div className="relative job-search-label-section rounded-lg  w-2/4 mt-4 mb-4 mx-auto singleselect2">
              <Select2
                data={jobData.map((job) => ({
                  id: job._id, // Unique ID for each option
                  text: job.title,
                  // title: type.value === "Block" ? "Contact with superadmin" : "", // Tooltip for Block status
                }))}
                className="jobsearchsector p-1 mr-2 w-full border rounded-lg appearance-none text-base/8"
                value={jobId} // Adjust based on your actual `value` logic
                onSelect={(e) => setjobId(e.target.value)}
                options={{
                  placeholder: "Select Status",
                  width: "100%",
                  theme: "classic",
                }}
              />
            </div>{" "}
            <div className="md:flex md:space-x-4 mb-4 md:w-2/4 mx-auto">
              {tabs.map((tab) => (
                <button
                  key={tab.value}
                  onClick={() => setSelectedTab(tab.value)}
                  className={`px-4 py-2 mt-2 m-1 rounded-full font-medium ${
                    selectedTab === tab.value
                      ? "activetabjob text-white"
                      : "bg-gray-100 text-gray-700"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <div className="space-y-4 hrp-Applications-content">
              {jobviewsdata != "" && <ChartComponent jobViews={jobviewsdata} />}
            </div>
          </div>
        </div>
        {data.length > 0 ? (
          <div className="lg:w-2/5 pt-5 profileheadlinediv-main-recent-app ">
            <div className="w-full  mx-auto  bg-white  hrp-Applications-section ">
              <div className=" hrp-Applications-heading">
                <h2 className="text-2xl font-semibold ">Recent Applications</h2>
              </div>
              <div className="space-y-4 hrp-Applications-content">
                {data.map((app, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between p-4 cursor-pointer transition duration-200 "
                  >
                    <div className="md:flex w-full items-center space-x-3 ">
                      {/* Application Icon */}
                      <div className="  flex justify-center items-center text-xl relative lg:w-32  hrp-profile-header-image">
                        <CircularProgressbar
                          value={
                            app?.analysis?.recommendation_percent !== "" &&
                            app?.analysis?.recommendation_percent !==
                              undefined &&
                            app?.analysis?.recommendation_percent !== null
                              ? app?.analysis?.recommendation_percent
                                  .toString()
                                  .includes("%")
                                ? parseFloat(
                                    app?.analysis?.recommendation_percent.replace(
                                      "%",
                                      ""
                                    )
                                  )
                                : parseFloat(
                                    app?.analysis?.recommendation_percent
                                  )
                              : 0
                          }
                          styles={buildStyles({
                            rotation: 0.5,
                            strokeLinecap: "butt",
                            textSize: "16px",
                            pathTransitionDuration: 0.5,
                            pathColor: `rgba(0, 128, 1, ${
                              app.analysis?.recommendation_percent / 100
                            })`,
                            textColor: "#f88",
                            trailColor: "#d6d6d6",
                            backgroundColor: "#3e98c7",
                            strokeWidth: 3,
                          })}
                        />{" "}
                        <label
                          htmlFor="companyLogo"
                          className="absolute transform -translate-x-1/2 -translate-y-1/2 text-gray-700 font-medium hrp-label-position"
                        >
                          <div className="w-full bg-white rounded-full flex items-center justify-center border-2 border-white hrp-profile-section-image ">
                            <img
                              alt={app?.profileId?.jobTitle}
                              className=" rounded-full"
                              src={domainpath + app?.profileId?.jobProfileImage}
                              onError={(e) => {
                                e.target.onerror = null; // Prevent infinite loop
                                e.target.src = `${domainpath}/uploads/deafultman.png`;
                              }}
                            />
                          </div>
                        </label>
                        <div
                          style={{ bottom: "-15px", left: "90px" }}
                          className="absolute  left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center hrp-profile-section-text"
                        >
                          <div className="text-center text-gray-700 font-medium text-lg">
                            {app.analysis?.recommendation_percent !== "" &&
                            app.analysis?.recommendation_percent !==
                              undefined &&
                            app.analysis?.recommendation_percent !== null
                              ? app.analysis?.recommendation_percent
                                  .toString()
                                  .includes("%")
                                ? app.analysis?.recommendation_percent
                                : app.analysis?.recommendation_percent + "%"
                              : ""}
                          </div>
                        </div>
                      </div>
                      <div className="hrp-Applications-content-section w-4/5">
                        {/* Job Title and Info */}
                        <h3
                          onClick={(e) => {
                            history.push(
                              `/dashboard/application/${app?._id}`,
                              app?.applicantId._id
                            );
                            handleChangeStatus(e, app?._id);
                          }}
                          className=" text-sm  font-medium"
                          style={{ color: "#003366" }}
                        >
                          {app?.profileId?.name}- {app?.profileId?.jobTitle}
                        </h3>
                        <p
                          onClick={(e) => {
                            history.push(`/jobs/${app?.jobId._id}`);
                          }}
                          className="text-base"
                          style={{ color: "#ffa500" }}
                        >
                          {app?.jobId?.title}
                        </p>
                        <p
                          className="text-sm font-medium"
                          style={{ color: "grey" }}
                        >
                          {app?.jobId?.location?.address}
                        </p>
                        <p className="text-sm">
                          {(() => {
                            const appliedDate = new Date(app?.appliedAt);
                            const currentDate = new Date();

                            // Check if the date is today
                            const isToday =
                              appliedDate.getDate() === currentDate.getDate() &&
                              appliedDate.getMonth() ===
                                currentDate.getMonth() &&
                              appliedDate.getFullYear() ===
                                currentDate.getFullYear();

                            return isToday
                              ? appliedDate.toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }) // Show time (HH:MM)
                              : appliedDate.toISOString().split("T")[0]; // Show date (YYYY-MM-DD)
                          })()}
                        </p>
                      </div>
                    </div>
                    {/* More options button */}
                    <div className="text-gray-600 hover:text-gray-900">
                      {/* <span className="material-icons">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M7 12C7 12.5304 6.78929 13.0391 6.41421 13.4142C6.03914 13.7893 5.53043 14 5 14C4.46957 14 3.96086 13.7893 3.58579 13.4142C3.21071 13.0391 3 12.5304 3 12C3 11.4696 3.21071 10.9609 3.58579 10.5858C3.96086 10.2107 4.46957 10 5 10C5.53043 10 6.03914 10.2107 6.41421 10.5858C6.78929 10.9609 7 11.4696 7 12ZM14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12ZM21 12C21 12.5304 20.7893 13.0391 20.4142 13.4142C20.0391 13.7893 19.5304 14 19 14C18.4696 14 17.9609 13.7893 17.5858 13.4142C17.2107 13.0391 17 12.5304 17 12C17 11.4696 17.2107 10.9609 17.5858 10.5858C17.9609 10.2107 18.4696 10 19 10C19.5304 10 20.0391 10.2107 20.4142 10.5858C20.7893 10.9609 21 11.4696 21 12Z" />
                      </svg>
                    </span> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      {loading && (
        <div className="RoadmapSpinnerDiv" id="RoadmapSpinnerDiv">
          <span className="RoadmapSpinner"></span>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
